define(['underscore', 'text!./templates/quick-step-progress.html'],
    (_, templateStr)=> {

        return [
            function () {
                return {
                    restrict: 'A',
                    scope: {
                        transitionFn: '&',
                        stepValidityFns: '=',
                        form: '=',
                        currentStep: '='
                    },
                    template: templateStr,
                    controller: ['$scope', ($scope) => {
                        $scope.customClasses = ['', '', '', 'gw-slq-quote-dot-small'];

                        $scope.transition = (targetStep) => {
                            $scope.transitionFn({targetStep: targetStep});
                        };
                    }]
                };
            }];
    });



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/common/directives/QuickStepProgress.js
 **/